<template>
  <div class="orangehrm-background-container">
    <div class="orangehrm-card-container">
      <oxd-text tag="h6" class="orangehrm-main-title">
        {{ $t('payroll.add_payslips_templates') }}
      </oxd-text>

      <oxd-divider />

      <oxd-form :loading="isLoading" @submit-valid="onSave">
        <oxd-form-row>
          <oxd-input-field
            v-model="payslipTemplates.templateName"
            :label="$t('payroll.payslips_templates_name')"
            :rules="rules.templateName"
            required
          />
        </oxd-form-row>
        <oxd-form-row>
          <oxd-input-field
            v-model="payslipTemplates.version"
            :label="$t('general.version')"
            :rules="rules.version"
            required
          />
        </oxd-form-row>
        <oxd-form-row>
          <oxd-input-field
            v-model="payslipTemplates.description"
            type="textarea"
            :label="$t('general.description')"
            :rules="rules.description"
            required
          />
        </oxd-form-row>
        <oxd-form-row>
          <oxd-input-field
            v-model="payslipTemplates.isActive"
            type="select"
            :options="statusOptions"
            :label="$t('general.status')"
          />
        </oxd-form-row>
        <oxd-form-row>
          <oxd-input-field
            v-model="payslipTemplates.templateAttachment"
            type="file"
            :accept="acceptFile"
            :label="$t('payroll.payslips_file')"
            :button-label="$t('general.browse')"
            :rules="rules.templateAttachment"
            required
          />
          <oxd-text class="orangehrm-input-hint" tag="p">
            {{ $t('general.accepts_up_to_1mb') }}
          </oxd-text>
        </oxd-form-row>

        <oxd-divider />

        <oxd-form-actions>
          <required-text />
          <oxd-button
            display-type="ghost"
            :label="$t('general.cancel')"
            @click="onCancel"
          />
          <submit-button />
        </oxd-form-actions>
      </oxd-form>
    </div>
  </div>
</template>

<script>
import {navigate} from '@ohrm/core/util/helper/navigation';
import {APIService} from '@/core/util/services/api.service';
import {required, maxFileSize} from '@ohrm/core/util/validation/rules';
import {
  PAYSLIP_TEMPLATE_DOCX_ACCEPT,
  normalizePayslipTemplateDocxAttachment,
  validPayslipTemplateDocxFile,
} from '@/orangehrmPayrollPlugin/util/payslipTemplateDocxFile';

const initialData = {
  templateName: '',
  version: null,
  isActive: '',
  description: '',
  templateAttachment: null,
};

export default {
  props: {
    allowedFileTypes: {
      type: Array,
      required: true,
    },
    maxFileSize: {
      type: Number,
      required: true,
    },
  },

  setup() {
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/payroll/payslip-templates',
    );
    return {
      http,
    };
  },

  data() {
    return {
      isLoading: false,
      payslipTemplates: {...initialData},
      rules: {
        templateName: [required],
        version: [required],
        description: [required],
        templateAttachment: [
          required,
          validPayslipTemplateDocxFile(),
          maxFileSize(this.maxFileSize),
        ],
      },
      statusOptions: [
        {
          id: 1,
          param: 'active',
          label: this.$t('general.active'),
        },
        {
          id: 2,
          param: 'inactive',
          label: this.$t('general.inactive'),
        },
      ],
    };
  },

  computed: {
    acceptFile() {
      return PAYSLIP_TEMPLATE_DOCX_ACCEPT;
    },
  },

  methods: {
    onCancel() {
      navigate('/payroll/viewPayslipsTemplates');
    },
    onSave() {
      this.isLoading = true;
      const templateAttachment = normalizePayslipTemplateDocxAttachment(
        this.payslipTemplates.templateAttachment,
      );
      this.http
        .create({
          ...this.payslipTemplates,
          templateAttachment,
          version: this.payslipTemplates.version.toString(),
          isActive: this.payslipTemplates.isActive.param === 'active',
        })
        .then(() => {
          return this.$toast.saveSuccess();
        })
        .then(() => {
          this.onCancel();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
